const GlobalSettingsPage = () => (
  <section className="uag-page-heading">
    <h1>Global Settings</h1>
    <p>Application-wide settings will be configured here.</p>
  </section>
);

export default GlobalSettingsPage;
